var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c01aba1bd2c76d5d4bd2ec0c63c5449734fb4bc8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["appsmith@appsmith"]={id:"c01aba1bd2c76d5d4bd2ec0c63c5449734fb4bc8"};
      